function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import Account from 'modules/Account';
import messages from '../../../messages';
import styles from '../DownloadDataModal.pcss';
import { useDevicePatientSetup } from './hooks';
import BgmResults from './BgmResults';
import Patient from './Patient';
const b = (chunk)=>/*#__PURE__*/ _jsx("b", {
        children: chunk
    });
const Info = ()=>{
    const activeProfileType = useSelector(Account.selectors.activeProfileType);
    if (activeProfileType !== Account.constants.PROFILE_TYPES.HCP) {
        return null;
    }
    return /*#__PURE__*/ _jsx("p", {
        className: "brand__paragraph mt-0 mb-8",
        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.infos.patientsResults), {
            values: {
                b
            }
        }))
    });
};
const DownloadSummary = ({ onSetComponent, onCancel })=>{
    useDevicePatientSetup();
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(styles.modal__content, 'h-auto'),
        children: [
            /*#__PURE__*/ _jsx(Info, {}),
            /*#__PURE__*/ _jsx(Patient, {
                onSetComponent: onSetComponent
            }),
            /*#__PURE__*/ _jsx(BgmResults, {
                onCancel: onCancel
            })
        ]
    });
};
export default DownloadSummary;
